import styled from 'styled-components';
import { inject } from 'mobx-react';
import chroma from 'chroma-js';

import { institutionLogoWidth } from 'js/config/style';

export default inject('bankAccount')(styled.div`
  display: grid;
  grid-template-columns: ${`calc(${institutionLogoWidth} + 2rem) 1fr`};
  border: 1px solid ${({ bankAccount }) => chroma(bankAccount.institution_color).darken()};
  border-radius: 0.25rem;
  min-height: ${({ height }) => height}rem;
`);
